export const SUCE_CODE = false;

// ❌ 不要再写 https://www.jikecc.com/api
// export const API_BASE = "https://www.jikecc.com/api";

// ✅ 统一用 /api，让 webpack/nginx 接管
// export const API_BASE = "/api";
export const API_BASE = "https://www.jikecc.com/api";

export const API_TZSQLIST = API_BASE + "/system/groupApplyList";        // 团长申请列表
export const API_TZSQSPZH = API_BASE + "/system/approveGroupApply";     // 团长申请审批
export const API_MSHZTJ = API_BASE + "/system/dailyStatsSummary";     // 每日统计汇总
export const API_SCGLYL = API_BASE + "/system/deleteAdmin";     // 删除管理员
export const API_GLYLIST = API_BASE + "/system/listAdmin";     // 管理员列表
export const API_XZGLYLB = API_BASE + "/system/addAdmin";     // 新增管理员
export const API_SCTUPIA = API_BASE + "/system/deletePicture";     // 删除图片
export const API_SCBANNE = API_BASE + "/system/uploadBanner";     // 上传banner
export const API_SXSJGLI = API_BASE + "/system/getSalesManager";     // 获取分销管理员,随机一个
export const API_TZGUANLI = API_BASE + "/system/groupManageList";     // 获取分销管理员,随机一个

export const API_YINGSHOU = API_BASE + "/system/revenueList";     // 营收记录（时间、事件、金额，按时间倒序）
export const API_ZLMYINSH = API_BASE + "/system/revenueSubStats";     // 子栏目营收统计（按事件名称汇总）










export const API_WCLOGIN = API_BASE + "/login/pwdLogin"			    // login
export const API_SCDLISH = API_BASE + "/system/delAgent"			// 删除代理商
export const API_SHDALIS = API_BASE + "/system/listApplyAgent"		// 申请的代理商列表
export const API_DLSLIST = API_BASE + "/system/listIsApplyAgent"	// 代理商管理列表
export const API_TIANDLS = API_BASE + "/system/addAgent"			// 添加代理商

export const API_SHTOUSU = API_BASE + "/system/auditComplaint"		// 审核投诉
export const API_CHULITS = API_BASE + "/system/dealComplaint"		// 处理投诉
export const API_SHHESPI = API_BASE + "/system/examineCommodity"	// 审核商品
export const API_DIDLIST = API_BASE + "/system/listOrderForm"		// 订单列表
export const API_GOOLIST = API_BASE + "/system/listCommodity"		// 商品审核列表
export const API_SHHUIXU = API_BASE + "/system/examineDiscountsMsg"	// 审核惠讯
export const API_HUXLIST = API_BASE + "/system/listDiscountsMsg"	// 惠讯列表
export const API_SHBMGOD = API_BASE + "/system/examineHelpSellGroup"// 审核帮卖信息
export const API_BMXLIST = API_BASE + "/system/listHelpSellGroup"	// 帮卖信息列表
export const API_LOOKWL = API_BASE + "/client/queryLogistics"		// 查询物流
export const API_DLDASZ = API_BASE + "/system/deleteAgentApply"		// 删除代理商招募信息

export const API_YWYLIEB = API_BASE + "/system/listAE"	// 业务员列表
export const API_YWYXINZ = API_BASE + "/system/addAE"	// 新增业务员
export const API_YWYSANC = API_BASE + "/system/delAE"	// 删除业务员

export const API_USERTOJ = API_BASE + "/system/userTotal"	    // 用户统计
export const API_YHJYMIX = API_BASE + "/system/txnTotal"	    // 交易统计明细
export const API_YHJYSHJ = API_BASE + "/system/listTxn"	        // 交易统计事件列表
export const API_YSTJMIX = API_BASE + "/system/revenueTotal"	// 营收统计明细
export const API_YSTJSHJ = API_BASE + "/system/listRevenue"	    // 营收统计事件列表
export const API_SBANNER = API_BASE + "/system/uploadBanner"	// 上传banner

export const API_PINGTTX = API_BASE + "/system/platformWithdraw"// 平台提现
export const API_PINGTYE = API_BASE + "/system/platformBalance"	// 平台余额

export const API_GLYLIEB = API_BASE + "/system/listAdmin"	// 管理员列表
export const API_GLYXINZ = API_BASE + "/system/addAdmin"	// 新增管理员
export const API_GLYSANC = API_BASE + "/system/delAdmin"	// 删除管理员
export const API_XIUGMMA = API_BASE + "/updatePassword"	    // 修改密码

export const API_MENDIAN = API_BASE + "/system/listShop"	// 门店列表




// WEBPACK FOOTER //
// ./src/assets/js/api.js